export default class UrlHelper {
    static getQueryParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    static setLanguageToUrl(url, language, languageList = []) {
        if (languageList.length > 0 && language && languageList.includes(language)) {
            const languagePart = language === 'en' ? '/' : `/${language}/`;
            const languageRegExp = new RegExp(`/?(${languageList.join('|')})/`, 'i');
            if (languageRegExp.test(url)) {
                return url.replace(languageRegExp, languagePart);
            } else if (url.indexOf('.') === -1) {
                return `${languagePart}${url.replace(/^\/+/, '')}`;
            }
        }
        return url;
    }

    static toPaybisFrontUrl(url, language) {
        const urlLocale = 'en' === language ? '' : `${language}/`;

        return `/${urlLocale}${url}`;
    }
}